import React from 'react';
import PropTypes from 'prop-types';
import { ResultsFeedbackWrapper, ButtonsWrapper } from './css';
import SvgIcon from '../icons/SvgIcon';
import PrimaryButton from '../buttons/PrimaryButton';

const ResultsFeedback = (props) => {
  const {
    icon, message, ctaLabel, ctaAction,
  } = props;

  return (
    <ResultsFeedbackWrapper>

      {(icon) ? <SvgIcon width={50} height={50} icon={icon} className="mb-4" /> : null}

      {(message) ? <p className="mb-5">{message}</p> : null}

      {(ctaLabel && ctaAction)
        ? (
          <ButtonsWrapper>
            <PrimaryButton onClick={ctaAction}>{ctaLabel}</PrimaryButton>
          </ButtonsWrapper>
        )
        : null}

    </ResultsFeedbackWrapper>
  );
};

ResultsFeedback.propTypes = {
  icon: PropTypes.string,
  message: PropTypes.string,
  ctaLabel: PropTypes.string,
  ctaAction: PropTypes.func,
};

export default ResultsFeedback;
